<template>
  <div class="vue-input-tag-wrapper">
    <input
      v-model="tag"
      class="new-tag tb-input"
      type="text"
      ref="tags"
      :placeholder="placeholder"
      @keyup.right.stop
      @keyup.left.stop
      @keydown.delete="removeLast($event)"
      @keydown.enter.space="add($event)"
    >

    <span
      v-for="(tag, index) in tags"
      :key="index"
      class="input-tag"
    >
      <span>{{ tag }}</span>

      <a
        class="remove pull-right ml-1"
        @click.stop.prevent="remove(tag)"
      >
        <span class="fas fa-times" />
      </a>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Search',
    },
    tags: Array,
  },
  data() {
    return {
      tag: '',
    };
  },
  methods: {
    focus() {
      this.$refs.tags.focus();
    },
    add($event) {
      const term = this.tag.trim();
      if (term.length && this.tags.indexOf(term) === -1) {
        this.$emit('add', term);
        this.tag = '';
      }
      $event.preventDefault();
    },
    remove(tag) {
      this.$emit('remove', tag);
    },
    removeLast() {
      if (!this.$refs.tags.value.length) {
        this.$emit('remove', this.tags[this.tags.length - 1]);
      }
    },
  },
};
</script>
